// On-screen visual of the printable unlock certificate.
export const Certificate = ({ title, code }) => {
  return (
    <div data-testid="certificate-preview" className="rounded-2xl border-2 border-gold/60 bg-obsidian p-8 sm:p-10 text-center">
      <div className="text-[11px] uppercase tracking-[0.35em] text-slate-400 mb-6">My Last Message</div>
      <h3 className="font-serif text-2xl sm:text-3xl text-gold-light mb-2">Unlock Certificate</h3>
      <p className="text-sm text-slate-400">
        Message: <span className="text-slate-100 font-medium">{title}</span>
      </p>
      <div className="font-mono text-xl sm:text-2xl tracking-[0.15em] font-bold text-gold my-7 break-all">
        {code}
      </div>
      <div className="text-sm tracking-wide text-slate-300 border-t border-gold/20 pt-5">
        www.mylastmessage.com.au
      </div>
    </div>
  );
};
